export default {
  en: {
    USER_GROUPS_HEADER: 'Manage User Groups',
    USER_GROUPS_ADD_BUTTON: 'Add New User Group',
    USER_GROUP_TABLE_COL_TYPE: 'Type',
    USER_GROUP_TABLE_COL_NAME: 'Name',
    USER_GROUP_TABLE_COL_ADMIN_REPORT: 'Admin Report View',
    USER_GROUP_TABLE_COL_READ_ONLY: 'Read Only',
    USER_GROUPS_TABLE_LOADING: 'Loading user groups',
    USER_GROUPS_TABLE_EMPTY: 'You have not created any user groups.',
    DELETE_USER_GROUP_SUCCESS: 'User group has been deleted',
    DELETE_USER_GROUP_FAILURE: 'Failed to delete user group',
    DELETE_GROUP_MODAL_TITLE: 'Delete User Group',
    DELETE_GROUP_CONFIRMATION_MODAL_TEXT: 'Are you sure you want to delete <strong>{groupName}</strong>?',
    EMPTY_LINKED_ITEMS: 'No items to add to group',
    CREATE_USER_GROUP_SUCCESS: 'User group created successfully',
    CREATE_USER_GROUP_FAILURE: 'Failed to create user group',
    UPDATE_USER_GROUP_SUCCESS: 'User group updated successfully',
    UPDATE_USER_GROUP_FAILURE: 'Failed to update user group',
    UNLINK_USER_SUCCESS: 'User removed successfully',
    UNLINK_USER_FAIL: 'Failed to remove user from user group',
    LINK_EXISTING_USER_SUCCESS: 'User successfully linked to group',
    LINK_EXISTING_USER_FAILURE: 'Failed to link user to group',
    LABEL_ADMIN_REPORT: 'Admin Report View',
    LABEL_READ_ONLY: 'Read Only',
    LABEL_LINKED_ITEMS: 'Linked Items',
    TOOLTIP_NAME: 'The name of this user group',
    TOOLTIP_TYPE: 'The type of items linked to this user group (can only be set when creating a new group)',
    TOOLTIP_NEW_TYPE: 'The type can only be set when creating a new group',
    TOOLTIP_ADMIN_REPORT: 'If enabled, users assigned to this group will have access to full admin reporting view. By default, assigned users will see a reporting view based on the type of this group: Publisher or Buyer.',
    TOOLTIP_READ_ONLY: 'If enabled, assigned users will only have read-only access to the linked Publishers or Buyers.',
    TOOLTIP_LINKED_ITEMS: 'Publishers or Buyers linked to this user group, depending on the selected type.',
    GROUP_ACTIONS_EDIT: 'Edit',
    MANAGE_USER_INVITES: 'Manage Invites',
    GROUP_ACTIONS_DELETE: 'Delete Group',
    SEARCH_USER_GROUPS: 'Search User Groups'
  }
};